<!--
 * @Author: your name
 * @Date: 2021-11-25 14:55:54
 * @LastEditTime: 2025-11-10 14:30:06
-->
<template>
  <div class="pages">
      <!-- <h1 class="title">电子契约面单</h1> -->
      <p class="sub_text">特别提醒：</p>
      <p class="sub_text">
        <span>禁寄物品：为维护社会公共安全和社会和谐稳定，维护国家利益，保障人民生命财产安全，</span>
        <span class="fontb colorRed">您不得交寄法律法规或相关政府主管部门规定禁止和限制寄递的物品以及本公司不予收寄或限制收寄的物品。快递服务组织在寄递过程中发现前述物品的，有权根据实际情况，采取包括但不限于退件、扣押、转交相关主管部门等措施。禁止、限制寄递物品被行政机关查扣后的损失与交寄物品的损失，由寄件人自行承担。因交寄禁寄物品造成快递服务组织或第三人人身财产损害及其他损失的，寄件人应当予以赔偿。</span>
      </p>
      <p class="sub_text">
        <span>保价说明：</span>
        <span class="fontb colorRed">信件、信件类物品、国家机关公文、身份证、户口本、护照、毕业证、政府类档案（如党员档案人事档案）、军功章、勋章等人身专属类证件不收寄；对于金银、珠宝、钻石、玉器、首饰、古玩、字画、邮票、艺术品、稀有金属等各类珍贵财物以及各类奢侈品等，单票货物的赔偿上限为人民币5000元。其他普通文件，暂不提供保价服务。未选择保价，则快递服务组织在十倍运费的限额内向您赔偿托寄物的实际损失。单件物品声明价值最高不得超出3万元，超出3万建议拆分多票发出。</span>
      </p>
      <p class="sub_text">
        <span class="fontb colorRed">请您确认，您已仔细、充分阅读并理解，本契约条款中加粗、红色字体标示的条款，因这些条款可能会明确您需要履行的义务或对您的权益有所限制。若您不同意本契约任何条款，您应当立即停止使用极兔速递服务。</span>
      </p>
      <p>托寄物标准：单件重量不超过50kg(含)；陆运长宽高三边长度之和不超过250cm，单边长度不超过150cm；</p>
      <h1 class="fontb">1、适用范围</h1>
      <p>本条款的缔约主体是您与极兔集团授权使用“极兔速递”品牌、从事快递业务、自主承担快递服务法律责任的企业法人，即本协议项下实际提供快件揽收和派送服务的快递营业机构（以下简称“快递服务组织”或“我们”）。</p>
      <h1 class="fontb colorRed">2、赔偿条款</h1>
      <p class="fontb colorRed">您已知悉并同意，快递服务组织是按托寄物的重量（包括体积重量与实际重量，具体规则请参见官网）收费，并非按托寄物的价值、预期收益收费，本着公平合理的原则，双方遵守以下赔偿约定及理赔规则：</p>
      <p class="fontb colorRed">2.1若因快递服务组织原因造成托寄物灭失、破损、短少的，快递服务组织将按以下标准赔偿：</p>
      <p class="fontb colorRed">2.1.1若您未选择保价，则快递服务组织在十倍运费的限额内向您赔偿托寄物的实际损失，双方另有约定的按约定执行。如您认为该赔偿标准不足以弥补您的损失，应根据托寄物的实际价值选择相同额度的保价服务。</p>
      <p class="fontb colorRed">2.1.2若您已选择保价且支付保价费用的，则破损、短少时快递服务组织将按照保价金额和实际损失的比例向您赔偿，托寄物灭失时最高不超过您托寄时保价的声明价值。</p>
      <p class="fontb colorRed">2.1.3您基于托寄物可能获得的收益、实际用途、商业机会等任何间接损失，快递服务组织不承担赔偿责任。</p>
      <p class="fontb colorRed">2.1.4延误的赔偿仅为免除本次服务费用（不含保价等附加费用）</p>
      <p class="fontb colorRed">2.1.5<span>声明价值：</span>鉴于快递服务组织无法评估托寄物的实际价值，当托寄物价值超过人民币1000元时，您应当在寄件时向快递服务组织如实声明；如您未声明且未保价，视为价值不超过1000元。</p>
      <p>2.1.6以下为本公司不予提供保价服务的寄递物品：</p>
      <p>①法律法规或相关主管部门规定的禁止和限制寄递的物品；</p>
      <p>②合同、发票、证券等无法核定价值的文件类货物；</p>
      <p>③其他本公司在极兔速递官网等渠道上公布的不予保价的物品。</p>
      <p>2.2自带原包装而快递服务组织无法进行内包装固定的贵重物品，请您谨慎包装，如到件时托寄物外包装无损，快递服务组织将不承担赔偿责任，请您慎重考虑寄递。</p>
      <h1 class="fontb">2.3理赔规则</h1>
      <p>2.3.1快递服务组织提供的保价服务，系基于您声明的托寄物价值收取费用，并基于托寄物实际受损价值进行赔偿，请您如实按照托寄物实际价值进行保价。快递服务组织采取“理赔审查”的方式，您应在寄件时如实按照托寄物的实际价值诚信保价，货物托运出现异常情形理赔时需提供托寄物品的相关价值证明（如发票、合同、付款凭证等），如无法证明托寄物品真实价值，不足额保价部分或超额保价部分均无法获得赔偿。</p>
      <p>2.3.2寄件人向快递服务组织提出理赔时，应提供以下证明材料：</p>
      <p>（1）寄件人的有效身份证明材料、授权书、含保价服务的寄件面单、发票、付款凭证及寄递物品的清单以及物品的损毁报告或检测报告等有效证明材料；</p>
      <p>（2）其他有效证明材料。</p>
      <p>寄件人在上述30天的理赔期限内未及时提供有关证明材料导致快递服务组织无法核实证明材料的真实性以及无法核实交寄物实际价值损失的责任由寄件人自行承担。</p>
      <p>2.3.3托寄物损坏残值由快递服务组织和您协商处理，如归您所有，快递服务组织在核定赔偿金额时将扣减残值。</p>
      <p>2.4您应理解，每票快件只能提出一次索赔，且与该快件相关的所有损失或损坏的赔偿是完全且最终的。</p>
      <h1 class="fontb">3、我们的服务</h1>
      <p class="fontb">3.1送达时限</p>
      <p>我们服务产品的时效说明与服务范围说明以官方网站（<a href="https://www.jtexpress.cn/" target="_blank">https://www.jtexpress.cn/</a>）上所公示的解释为准，您可以登录官方网站查询或拨打我们的客服热线咨询。</p>
      <h1 class="fontb">3.2签收</h1>
      <p>您同意并促使收件人同意快递服务组织可以根据实际情况的便利，按如下方式之一，安全、合理地投递快件：</p>
      <p>（1）交由收件人本人签收；</p>
      <p>（2）交由收件人的同住人或指定的代收人签收；</p>
      <p>（3）投递至收件地址范围内的代收点或自提柜；</p>
      <p>（4）按收件人或寄件人指定的其他方式投递。</p>
      <p>快递员在收件人要求或取得收件人同意的情况下，可以将快件投递至收件人指定地址，或当地政府、居委、物业等专门安排的快件投递场所。</p>
      <p>快递服务组织按以上方式之一投递快件且快件外包装完好的，视为该次快递服务履行完毕。</p>
      <h1 class="fontb">3.3退件</h1>
      <p>收件地址不详无法送达的、收件人拒收的或非因快递服务组织原因派送未成功的，快递服务组织有权退回快件或按寄件人明示的合理要求处理，相应费用由寄件人承担。</p>
      <p>3.4查询服务</p>
      <p>我们向寄件人提供自交寄之日起一年内的订单及物流信息查询服务。</p>
      <h1 class="fontb">4、您的义务</h1>
      <p>4.1您确认，在您因工作需要使用我们的服务时，您已充分获得您工作单位的授权，并已充分阅读、理解并接受本条款的全部内容。</p>
      <p>4.2为符合法律法规对快件寄递安全的要求，保证托寄物安全送达，您在寄件时应履行以下义务：</p>
      <p>4.2.1确保托寄物不包含国家机关公文、国家保护野生动物和濒危野生动物及其制品、假冒伪劣和侵权物品等法律法规禁止和限制寄递的物品，不得通过寄递渠道危害国家安全、公共安全和公民、法人、其他组织的合法权益。</p>
      <p>4.2.2您应准确、完整、如实地填写快递面单并提供有效身份证件进行实名验证，若您填写的面单信息与快递服务组织提供的电子物流轨迹信息不一致的，您知悉并认可最终以电子物流轨迹信息为准；您为法人的，应提供法人证照及法定代表人或相关负责人的身份证件进行实名验证。您同意快递服务组织记录、留存相关证件信息。</p>
      <p>4.2.3快递服务组织有权对您交寄物品进行开箱验视，对于无法判定内件属性的交寄物品，有权要求您出具有效证明；您不配合验视的，快递服务组织有权不予揽收或退回已揽收；快件托寄物需要办理审批、检验等手续的，您应提交办理完相关手续的证明文件。快递服务组织可以对托寄物内件拍照取证，如发现禁止或限制寄递的物品，有权移交相关部门处理。</p>
      <p>4.2.4您应如实申报托寄物的名称、性质、数量和价值，并准确填写您、收件人的名称、地址、联系电话等信息。</p>
      <p>4.2.5您应根据托寄物的性质（尤其是易碎品、液体、气体或其他），提供充分的防破损、防漏、防爆措施，以便我们保障安全运输。</p>
      <p>4.2.6若您自备包装物的，需遵守《邮件快件包装管理办法》，选用绿色环保、无毒无害的包装物，包装操作时除注重安全外也应注重环保和节约；如因寄递的快件包装不符合上述要求的，快递服务组织有权要求您更换符合环保要求的包装，由此造成的一切损失由您承担。因快件包装不善造成快件损毁、遗失的，快递服务组织不予赔偿；因此造成快递服务组织或第三方人身财产损害的，您应当予以赔偿。您委托快递服务组织进行包装的，快递服务组织有权收取相应的包装费用。</p>
      <h1 class="fontb colorRed">4.3请您理解，当出现以下情况时，您应承担相应的赔偿责任：</h1>
      <p class="fontb colorRed">（1）因托寄物有安全隐患、质量缺陷或包装破损，致使其他托寄物、运输工具、机械设备被污染腐蚀、损坏，或造成人身伤亡的；</p>
      <p class="fontb colorRed">（2）因托寄物属于或含有禁止或限制寄递物品而被查没、扣留或变更配送路线，导致其他托寄物时效延误或价值丧失，给快递服务组织或第三人造成经济损失的；</p>
      <p class="fontb colorRed">（3）因您违反第4.2条的义务导致快递服务组织或第三人承担行政处罚、民事赔偿等所造成的各项经济损失，您应承担赔偿责任。</p>
      <p class="fontb colorRed">4.3.1 若我们发现您违背诚实信用原则，通过虚构事实、提供虚假材料（包括但不限于价值证明、损害照片等）或其他不正当手段申请理赔或骗取其他权益，我们将采取下述一种或多种措施维护我们的权益：</p>
      <p class="fontb colorRed">（1）我们将拒绝受理您的理赔事项及/或承担赔偿责任，且无须承担违约责任；</p>
      <p class="fontb colorRed">（2）我们将停止为您提供寄递服务，且无须承担违约责任；</p>
      <p class="fontb colorRed">（3）对于您已经获取的不当得利，我们将有权索回且有权要求您承担相应责任；</p>
      <p class="fontb colorRed">（4）若上述情形严重或者出现3次/单以上，我们将移交公安等部门予以处理。</p>
      <h1 class="fontb colorRed">4.4 服务费</h1>
      <p class="fontb colorRed">4.4.1请您仔细阅读并遵守以下服务费条款：</p>
      <p class="fontb colorRed">（1）已经收寄的到付快件，如收件人尚未付费，您要求更改为由您付费的，您应支付附加服务费；</p>
      <p class="fontb colorRed">（2）您指示在物流中心、保税区等需要支付出/入仓费或其他额外费用的特殊地址收取或派送快件时，您或您指定付款人应当偿还快递服务组织垫付的上述出/入仓费等额外费用，并支付附加服务费，该等费用金额以快递服务组织取得的收费凭证为准；</p>
      <p class="fontb colorRed">（3）春节等法定节假日和“双十一”等业务高峰期间您需要提供服务的，可能会加收附加服务费，该等费用以快递服务组织官网、公众号、APP等平台公示为准，您可以登录快递服务组织官方网站或拨打快递服务组织客服热线咨询。若您在价格变更后继续寄件，表示您同意按照变更后的价格支付费用；</p>
      <p class="fontb colorRed">（4）无法派送的托寄物，若您要求退回，则双程费用均由您承担。</p>
      <p class="fontb colorRed">（5）如因收件人拒绝支付运费、税金、报关仓储费或者其他原因派送不成功，快递服务组织将与您联系获取处理意见（包括但不限于放弃货物所有权、退回、销毁等），您应在规定时间内予以回复，如因您无法联系、未在规定时间内回复等造成货物滞留，自快递服务组织通知之日（指快递服务组织客服、短信、官网路由提示或展示的节点异常之日，若有多个节点异常，则以第一个节点异常之日为准）起超过 70 个自然日的，视为您放弃对货物的所有权，快递服务组织有权对货物进行处理，产生的处理费用由您承担。</p>
      <h1 class="fontb">4.4.2留置权</h1>
      <p>您应理解，若您或您指定的付款人未付清费用的，快递服务组织有权留置托寄物，留置后您的债务履行期限为 2 个月（自揽收快件之日起计算），但托寄物性质不能留置的除外。债务履行期限届满，您或指定付款人仍未付清费用的，将视为您放弃对留置物的所有权，快递服务组织可以变卖、拍卖、处置留置物并优先受偿。变卖、拍卖所得价款应优先支付快递服务组织为行使留置权所支出的费用和保管费以及变卖/拍卖/处置留置物的费用，再偿付拖欠快递服务组织的费用；如有余额，可根据您的要求汇至您指定账户。</p>
      <h1 class="fontb">5、个人信息的收集及使用</h1>
      <p>5.1 您同意遵守极兔速递的隐私政策及其后续修订、更新的内容，同意快递服务组织按照法律法规和隐私政策的规定处理您提供的运单信息。</p>
      <p>5.2 通过极兔速递自有渠道（如官方网站、微信小程序“极兔速递+”）下单寄件，您同意使用隐私面单。</p>
      <p>5.3 快递服务组织会以电话、电子邮件、手机短信等方式告知、发送的产品/业务介绍、推广促销信息及其他商业性信息。您不同意继续接收以上信息的，可以通过短信或拨打快递服务组织客服热线方式退订。</p>
      <h1 class="fontb">6、其他</h1>
      <p>6.1 如果本条款中的某条款被法院或政府机构认定为无效或部分无效，则双方同意除无效条款外仍应执行本合同其它条款，部分有效条款在其可执行的范围内仍继续执行。</p>
      <p class="fontb colorRed">6.2 本条款履行过程中如发生争议，双方应友好协商解决。协商不成的，任何一方均应向上海市青浦区有管辖权的人民法院提起诉讼。</p>
      <p>6.3 本条款以上约定的托寄物赔偿标准仅适用于从收寄到投递的全过程均发生在中华人民共和国境内的国内快件。</p>
  </div>
</template>

<script>
export default {
  name: 'ElectronicContract',
}
</script>

<style scoped lang="scss">
$color999: #999999;
$color333: #333333;
.pages {
  background: #ffffff;
  box-sizing: border-box;
  padding: 16px;
  font-size: 14px;
  color: $color333;
  ::-webkit-scrollbar {
    display: none;
  }
}
.fontb {
  font-weight: bold;
  color: $color333;
  font-size: 14px;
}

.colorRed {
  color: #e60012;
}

p {
  margin: 15px 0;
}
p, span {
  font-family: 宋体;
  line-height: 24px;
  letter-spacing: 2px;
}
.title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}
</style>
